// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * Define Speech Recognizer output formats.
 * @class OutputFormat
 */
export enum OutputFormat {
    /**
     * @member OutputFormat.Simple
     */
    Simple = 0,

    /**
     * @member OutputFormat.Detailed
     */
    Detailed,
}
